module.exports = __webpack_public_path__ + "img/739.2187335d.gif";